<div class="container-fluid">
  <div class="row d-flex justify-content-start align-items-center">
    <button class="nav-back" [routerLink]="['/readiness-admin-form', projectId]"><fa-icon [icon]="faChevronLeft"
        size="lg"></fa-icon></button>
    <h1 class="title">{{titleValue}}</h1>
  </div>
</div>



<div class="container-fluid mt-4">
  <div class="card shadow-sm p-4">
    <div class="table-responsive">
      <div style="display: flex; justify-content: end;">
        <button class="btn mb-2" (click)="saveAllTableData()">Save All</button>
      </div>

      <div *ngFor="let group of groupedData; let sectionIndex = index">
        <div class="section-header" (click)="toggleCategory(group.sectionName)">
          <span>
            {{ group.sectionName }}
            <fa-icon [icon]="categoryToggle[group.sectionName] ? faChevronDown : faChevronRight" size="lg"></fa-icon>
          </span>

          <span>
            <button *ngIf="categoryToggle[group.sectionName]" title="Add new row" (click)="addRow(group)"
              class="btn btn-sm ml-2" (click)="$event.stopPropagation()">
              <fa-icon style="color: white; cursor: pointer;" [icon]="faPlus"></fa-icon>
            </button>
          </span>
        </div>

        <table class="table table-bordered table-hover" *ngIf="categoryToggle[group.sectionName]"
          style="margin-top: 10px;">
          <thead style="background-color: #3f84c0; color: white;">
            <tr>
              <th>Options</th>
              <th class="column-6">
                Values
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let column of group.data; let i = index" draggable="true"
              (dragstart)="onDragStart($event, group, i)" (dragover)="onDragOver($event)"
              (drop)="onDrop($event, group, i)" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)"
              [class.drag-over]="dragOverIndex === i && dragOverGroup === group.sectionName">
              <td>
                <input *ngIf="column.isNew" [(ngModel)]="column.Description" class="form-control"
                  placeholder="Enter name" />
                <span *ngIf="!column.isNew">{{ column.Description }}</span>
              </td>
              <td style="display: flex;">
                <input type="number" [(ngModel)]="column.Value" class="form-control" />
                <span (click)="deleteRow(group, i)" title="Delete row">
                  <fa-icon style="color: red; cursor: pointer; margin-left: 10px;" [icon]="faTrash"></fa-icon>
                </span>
              </td>
            </tr>
            <tr *ngIf="group.data.length === 0">
              <td colspan="2" class="text-center text-muted">No rows available</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>